import AppConfig from "config";
import axios from "axios";
const jwtToken = localStorage.getItem('access_token');

const UsuariosMenuController = {
    async ListMenus() {
        try {
          const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO+`users_page/get_menu_user`, {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          });
          return response.data;
        } catch (error) {
          console.error("Error fetching transcripts:", error);
          throw error;
        }
      },
      }

export default UsuariosMenuController;